/* Single Post.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "../../../sass/layouts/cpt_templates/single-post.scss";

(function() {
    // get doc body.
    const body = document.body;

    // add id to form block if on single campaign template.
    if (body.classList.contains('single-campaign')) {
        const formBlock = document.querySelector('.block-form');
        formBlock.setAttribute('id', 'cpt-form');
    }
})();
